import { render } from "./TopBenefitComponent.vue?vue&type=template&id=06e60ced"
import script from "./TopBenefitComponent.vue?vue&type=script&lang=js"
export * from "./TopBenefitComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/TopBenefitComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06e60ced"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06e60ced', __exports__)) {
    api.reload('06e60ced', __exports__)
  }
  
  module.hot.accept("./TopBenefitComponent.vue?vue&type=template&id=06e60ced", () => {
    api.rerender('06e60ced', render)
  })

}


export default __exports__